import React from "react";
import { useAuth } from "react-oidc-context";
import Banner from "./banner";
import Navigation from "./Navigation";

const Header = ({ user, signOut }) => {
  const auth = useAuth();

  return (
    <div className="sticky top-0 z-50">
      <Banner user={auth.user} auth={auth} />
      <div style={{ "paddingBottom": "1.25rem" }}>
        <Navigation user={auth.user} />
      </div>
    </div>
  );
};

export default Header;
